export const engagementAppGroupIdMediaLibraryAssetDataAssetId =
  "/engagement/:app_group_id/media_library_asset_data/:asset_id";
